var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIndicator4 = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 32,
  height: 32,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M28 24h3v-4h-3",
  stroke: "#EC7F00",
  strokeWidth: 2,
  strokeMiterlimit: 10
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M1 10h2M8 6.5a2.5 2.5 0 0 0-5 0v19a2.5 2.5 0 0 0 5 0v-19ZM13 6.5a2.5 2.5 0 0 0-5 0v19a2.5 2.5 0 0 0 5 0v-19ZM18 6.5a2.5 2.5 0 0 0-5 0v19a2.5 2.5 0 0 0 5 0v-19ZM23 6.5a2.5 2.5 0 0 0-5 0v19a2.5 2.5 0 0 0 5 0v-19ZM28 6.5a2.5 2.5 0 0 0-5 0v19a2.5 2.5 0 0 0 5 0v-19Z",
  stroke: "#EC7F00",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  strokeLinecap: "square"
})));
export default SvgIndicator4;